module.exports = __webpack_public_path__ + "static/media/fallBack.54ed6793.svg";